import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const bloomingdaleConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Bloomingdale Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Bloomingdale, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_bloomingdale',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Bloomingdale',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Bloomingdale Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the established neighborhoods 
     and well maintained properties of <strong>Bloomingdale</strong> with expert 
     tree care. This popular East Hillsborough community has mature trees 
     throughout its subdivisions that have grown large enough to create real 
     hazards near homes, driveways, and utility lines. As Florida's storm season 
     intensifies each year, staying ahead of those hazards is essential.`,

    `We specialize in <strong>hazardous tree removal and canopy management in 
     established suburban communities</strong> large overhanging limbs near 
     rooftops and pool cages, storm split trunks, trees with root issues near 
     pavement and structures, and density thinning that reduces your property's 
     wind load risk before hurricane season. We work cleanly and efficiently.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout <strong>Bloomingdale</strong> and surrounding 
     <strong>East Brandon</strong> communities keeping your home and 
     landscape safe and well maintained all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Bloomingdale, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Bloomingdale = () => <LocationPage config={bloomingdaleConfig} />;
export default Services_Bloomingdale;
